// extracted by mini-css-extract-plugin
export default {"component_homepage_hero":"homepage-hero_component_homepage_hero__z8g4a"};